import AIVoiceDemo from '@/pages/AIVoiceDemo';
import BrainIcon from '@/shared/icons/BrainIcon';
import ColorIcon from '@/shared/icons/ColorIcon';
import ConnectIcon from '@/shared/icons/ConnectIcon';
import DashboardIcon from '@/shared/icons/DashboardIcon';
import EditIcon from '@/shared/icons/EditIcon';
import EyeIcon from '@/shared/icons/EyeIcon';
import GraphIcon from '@/shared/icons/GraphIcon';
import PersonIcon from '@/shared/icons/PersonIcon';
import SecureIcon from '@/shared/icons/SecureIcon';
import ZapIcon from '@/shared/icons/ZapIcon';

import { SidebarStepEnum } from '@/components/Chatbot/Details/SidebarStepEnum';
import AiVoiceIcon from '@/shared/icons/AiVoiceIcon';

export const chatbotNavItems = [
  {
    id: SidebarStepEnum.OVERVIEW,
    type: 'link',
    icon: <EyeIcon />,
    label: 'Preview',
    link: ''
  },
  {
    id: SidebarStepEnum.TABS,
    type: 'link',
    icon: <DashboardIcon />,
    label: 'Tabs',
    link: '/tabs',
    permission: 'tabs'
  },
  {
    id: SidebarStepEnum.INSIGHTS,
    type: 'link',
    icon: <GraphIcon />,
    label: 'Insights',
    link: '/insights',
    permission: 'insights'
  },
  {
    id: SidebarStepEnum.INTEGRATIONS,
    type: 'link',
    icon: <ConnectIcon />,
    label: 'Integrations',
    link: '/integrations',
    permission: ['api_key', 'integrations']
  },
  {
    id: SidebarStepEnum.SAFETY,
    type: 'link',
    icon: <SecureIcon />,
    label: 'Safety',
    link: '/safety',
    permission: 'chatbot_safety'
  },

  {
    type: 'group',
    icon: '',
    label: 'Customize',
    link: '/',
    items: [
      {
        id: SidebarStepEnum.STYLING,
        type: 'link',
        icon: <ColorIcon />,
        label: 'Styling',
        link: '/styling',
        permission: 'chatbot_styling'
      },
      {
        id: SidebarStepEnum.KNOWLEDGE,
        type: 'link',
        icon: <BrainIcon />,
        label: 'Knowledge',
        link: '/knowledge',
        permission: 'chatbot_knowledge'
      },
      {
        id: SidebarStepEnum.PERSONALITY,
        type: 'link',
        icon: <PersonIcon />,
        label: 'Personality',
        link: '/personality',
        permission: 'chatbot_personality'
      },
      {
        id: SidebarStepEnum.SET_UP,
        type: 'link',
        icon: <EditIcon />,
        label: 'Core settings',
        link: '/setup',
        permission: 'chatbot_core_settings'
      },
      {
        id: SidebarStepEnum.POWER_UPS,
        type: 'link',
        icon: <ZapIcon />,
        label: 'Power-Ups',
        link: '/powerups',
        permission: 'chatbot_powerups'
      },
      {
        id: SidebarStepEnum.REALTIME_VOICE,
        type: 'link',
        icon: <AiVoiceIcon />,
        label: 'Realtime Voice',
        link: '/realtime-voice',
        tierFeature: 'realtime_voice_access'
      }
    ]
  }
];

export default chatbotNavItems;
